<aside class="__nav-main">

  <button [routerLink]="['/consults/new']" routerLinkActive="router-link-active" class="flex align-center btn-action" [hasPermission]="['CNCF']" action="D-NONE">
    <svg>
      <use href="assets/icons/plus.svg#plus" />
    </svg>
    <span>New consult</span>
  </button>

  <a [routerLink]="['/metrics']" routerLinkActive="active-link" *ngIf="(userLevel$ | async) == eUserLevel.CompanyLevel || (userLevel$ | async) == eUserLevel.HospitalLevel">
    <svg>
      <use href="assets/icons/dashboard.svg#dashboard" />
    </svg>
    <span>Metrics</span>
  </a>

  <a [routerLink]="['/consults']" routerLinkActive="active-link" [hasPermission]="['GACF']" action="D-NONE">
    <svg>
      <use href="assets/icons/consults.svg#consults" />
    </svg>
    <span>Consults</span>
  </a>

  <a [routerLink]="['/doctors']" routerLinkActive="active-link" *ngIf="(userLevel$ | async) == eUserLevel.HospitalLevel || (userLevel$ | async) == eUserLevel.CompanyLevel" [hasPermission]="['GDOC']" action="D-NONE">
    <svg>
      <use href="assets/icons/doctors.svg#doctors" />
    </svg>
    <span>Doctors</span>
  </a>


  <a [routerLink]="['/hospitals']" routerLinkActive="active-link" *ngIf="(userLevel$ | async) == eUserLevel.CompanyLevel" [hasPermission]="['GAHOS']" action="D-NONE">
    <svg>
      <use href="assets/icons/hospitals.svg#hospitals" />
    </svg>
    <span>Hospitals</span>

  </a>
  <a [routerLink]="['/programs']" routerLinkActive="active-link" *ngIf="(userLevel$ | async) == eUserLevel.CompanyLevel" [hasPermission]="['GAHOSP']" action="D-NONE">
    <svg>
      <use href="assets/icons/programs.svg#programs" />
    </svg>
    <span>Programs</span>

  </a>
  <a [routerLink]="['/web/dbq/doctors']" routerLinkActive="active-link" *ngIf="(userLevel$ | async) == eUserLevel.CompanyLevel" >
    <svg>
      <use href="assets/icons/dbq.svg#dbq" />
    </svg>
    <span>DBQ</span>

  </a>
  <a [routerLink]="['/users']" routerLinkActive="active-link" *ngIf="(userLevel$ | async) == eUserLevel.CompanyLevel" > <!--*ngIf="isAdmin && !isOrganizationUser"-->
    <svg>
      <use href="assets/icons/team.svg#team" />
    </svg>
    <span>Users</span>
  </a>

  <a [routerLink]="['/team']" routerLinkActive="active-link" *ngIf="(userLevel$ | async) == eUserLevel.HospitalLevel" [hasPermission]="['UHOSU']" action="D-NONE">
    <svg>
      <use href="assets/icons/team.svg#team" />
    </svg>
    <span>Team</span>
  </a>

  <a [routerLink]="['/timesheet']" routerLinkActive="active-link" *ngIf="(userLevel$ | async) == eUserLevel.DoctorLevel || (userLevel$ | async) == eUserLevel.CompanyLevel">
    <svg>
      <use href="assets/icons/timesheets.svg#timesheets" />
    </svg>
    <span>Timesheets</span>
  </a>

  <a [routerLink]="['/web/shifts']" routerLinkActive="active-link" *ngIf="(userLevel$ | async) == eUserLevel.CompanyLevel" > <!--*ngIf="isAdmin && !isOrganizationUser"-->
    <svg>
      <use href="assets/icons/shifts.svg#shifts" />
    </svg>
    <span>Shift</span>
  </a>

  <a [routerLink]="['/web/auditlogs']" routerLinkActive="active-link" *ngIf="(userLevel$ | async) == eUserLevel.CompanyLevel" > <!--*ngIf="isAdmin  && !isOrganizationUser"-->
    <svg>
      <use href="assets/icons/audit-log.svg#audit-log" />
    </svg>
    <span>Audit Log</span>
  </a>

  <a [routerLink]="['/web/access-roles']" routerLinkActive="active-link" [hasPermission]="['GAHOSU']" action="D-NONE">
    <svg>
      <use href="assets/icons/acess-role-icon.svg#acess-role" />
    </svg>
    <span>Access Roles</span>
  </a>

  <!-- //Doctor navbar -->
  <!-- <a [routerLink]="['/web/doctor/consults']" routerLinkActive="active-link" *ngIf="(userLevel$ | async) == eUserLevel.DoctorLevel"> <!--*ngIf="isDoctor"
    <svg>
      <use href="assets/icons/dashboard.svg#dashboard" />
    </svg>
    <span>My Consults</span>
  </a> -->

  <!-- <a (click)="goToDoctorSchedule()" routerLinkActive="active-link"> <!--*ngIf="isDoctor"-->
   <!-- <svg>
      <use href="assets/icons/dashboard.svg#dashboard" />
    </svg>
    <span>My Schedule</span>
  </a> -->

  <!-- <a (click)="goToDoctorProfile()" routerLinkActive="active-link"> <!--*ngIf="isDoctor"-->
  <!--  <svg>
      <use href="assets/icons/dashboard.svg#dashboard" />
    </svg>
    <span>My Profile</span>
  </a> -->

  <!-- <a (click)="goToHospitalTeams()" routerLinkActive="active-link"> <!--[hasPermission]="['GAHOSU']" action="D-NONE"-->
  <!--  <svg>
      <use href="assets/icons/dashboard.svg#dashboard" />
    </svg>
    <span>Team Access</span>
  </a> -->

  <!-- <a (click)="goToDBQDoctorAppointments()" routerLinkActive="active-link"> <!--*ngIf="isDBQDoctor"-->
  <!--  <svg>
      <use href="assets/icons/dashboard.svg#dashboard" />
    </svg>
    <span>Manage Appointments</span>
  </a> -->

  <!-- <a (click)="goToDBQDoctorProfile()" routerLinkActive="active-link"> <!--*ngIf="isDBQDoctor"-->
  <!--  <svg>
      <use href="assets/icons/dashboard.svg#dashboard" />
    </svg>
    <span> Manage Profile</span>
  </a> -->

</aside>
